module.exports = __webpack_public_path__ + "img/code_img3.980f7579.jpg";